import React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect, dispatch } from 'react-redux';
import { firebaseConnect, isLoaded, isEmpty, helpers as firebaseHelpers } from 'react-redux-firebase'
import Link from 'gatsby-link';
import { toggleSubscribe } from '../state/app';
import { withRouter } from 'react-router';
import { Scrollbars } from 'react-custom-scrollbars';
import { Helmet } from 'react-helmet';

class FAQPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentFaq: null
    }
  }

  setCurrentFaq(index) {
    index = this.state.currentFaq == index ? null : index;
    this.setState({
      currentFaq: index
    });
  }

  toggleActive(id) {
    let container = document.querySelector('#faqs');
    let active = container.querySelector('.faq-item.active');
    let newItem = document.querySelector(id);
    newItem.classList.toggle('active');
    if(active) {
      active.classList.remove('active');
    }
  }

  render () {
    let content = "Loading...";
    let title = "";

    function Faqs (props) {

      const faqs = props.items.sort(function (a, b) {
        return a.priority - b .priority;
      });
      const items = faqs.map((faq, index) =>
        <div className={`faq-item ${props.parent.state.currentFaq === index ? 'active' : ''}`}
        key={`question${index}`}
        id={`question${index}`}>
          <h2 className="minor cursor"
             onClick={() => props.parent.toggleActive(`#question${index}`)}>{faq.question}</h2>
          <p dangerouslySetInnerHTML={{__html: faq.answer}}></p>
        </div>
      );
      return (
        <div className="faq-items">{items}</div>
      )
    }
    if(isLoaded(this.props.state.faqs)) {
      title = (
        <h1 className="major">{this.props.state.faqs.title}</h1>
      )
      content = (<Faqs items={this.props.state.faqs.items} parent={this} />)
    }
    return (
      <div id="faqs" className={`page faqs`}>
        <Helmet>
            <title>FAQ - Micro-communities of City Car Owners</title>
            <meta name="description" content={'ParkYou! unites micro-communities of city car owners to instantaneously find street parking. We are launching in Summer 2018. Join Us!'} />
        </Helmet>
        <Scrollbars className="article">
          {title}
          {content}
        </Scrollbars>
      </div>
    )
  }
}

const  mapStateToProps = ({app, firebase}) => ({
    state: {
      faqs: firebase.data.faqs
    }
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
  firebaseConnect([
    'faqs' // { path: '/todos' } // object notation
  ]),
  connect(
      mapStateToProps,
      mapDispatchToProps
  )
)(withRouter(FAQPage))


// WEBPACK FOOTER //
// ./src/pages/faq.js